<template>
  <div class="contact">
    <Swiper class="swiper_c" />
    <div class="box">
      <div class="mail">
        <img src="@/assets/images/contact/message.png" alt="" />
        <div class="text">
          <div class="title">合作邮箱</div>
          <div class="content">biz@fintechgp.com</div>
        </div>
      </div>
      <div class="mail mails">
        <img src="@/assets/images/contact/map.png" alt="" />
        <div class="text">
          <div class="title">公司地址</div>
          <div class="content">浙江省杭州市滨江区浦沿街道南环路3730号源越科技大楼6层608室</div>
        </div>
      </div>
    </div>
    <myMap />
  </div>
</template>

<script>
import Swiper from "./Swiper";
import myMap from "./map";
export default {
  name: "contact",
  components: {
    myMap,
    Swiper,
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 85%;
  margin: 80px 0;

  .mail {
    display: flex;
    align-items: start;
    width: 600px;
    img {
      width: 118px;
      height: 118px;
    }
    .text {
      display: flex;
      flex-direction: column;
      align-items: start;
      margin-left: 20px;
      justify-content: space-between;
      .title {
        font-size: 24px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        color: #666666;
        line-height: 45px;
        margin-bottom: 10px;
      }
      .content {
        font-size: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
  }
  .mails{
    flex: 1;
  }
}

.contact {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.swiper_c {
  width: 100%;
  height: 500px;
}

@media screen and (max-width: 768px) {
  .contact {
    padding-bottom: 0.3rem;
  }

  .banner {
    height: 1.5rem;
  }

  .title {
    line-height: 0.8rem;
    font-size: 0.8rem;
  }

  .title2 {
    margin-top: 0.3rem;
    line-height: 0.4rem;
    font-size: 0.4rem;
  }
}

@media screen and (max-width: 500px) {
  .title {
    line-height: 0.6rem;
    font-size: 0.6rem;
  }
}
</style>